// extracted by mini-css-extract-plugin
module.exports = {"rightScreen":"HomeImage_rightScreen__rroKC"};